import { DEFAULT_BORDER } from "../const/excel.const";
/**
 * @description 엑셀 헤더 및 DB
 * (순서대로 나열하기 위함 + 빈칸 매칭도 해야하므로 => excelToDBKeyPairMap와 별개로 선언함)
 */
export const excelHeader = [
    "종류",
    "분류",
    "관리코드",
    "제품명",
    "모델명",
    "사양",
    "제조사",
    "위치",
    "재고",
    "단위",
    "상태",
    "단가",
    "합계",
    "제품 사진",
    "스펙 사진",
    "",
    "총 재고",
    "총 금액",
];
export function makeHeader(ws) {
    // 헤더 로우 추가
    ws.addRow(excelHeader);
    // 헤더 스타일 지정
    ws.getRow(1).eachCell((cell) => {
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "A5A5A5" },
        };
        cell.font = {
            size: 10,
            bold: true,
            color: { argb: "FFFFFF" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = DEFAULT_BORDER;
    });
    // 열 너비 자동 조정
    excelHeader.forEach((_, idx) => {
        ws.getColumn(idx + 1).width = 15;
    });
    // 자동 필터 적용
    ws.autoFilter = {
        from: "A1",
        to: `${String.fromCharCode(64 + excelHeader.length)}1`,
    };
    // 첫 줄(헤더) 고정
    ws.views = [{ state: "frozen", ySplit: 1 }];
    // 숫자 형식 지정
    ws.getColumn("I").numFmt = "#,##0개";
    ws.getColumn("L").numFmt = '₩#,##0;-₩#,##0;"-"';
    ws.getColumn("M").numFmt = '₩#,##0;-₩#,##0;"-"';
}
